// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3duje","label":"SetPasswdForm_label__3o7aX"};